var map = {
	"./Payment-Auth-C4.svg": [
		37526,
		7526
	],
	"./Payment-Auth-C4CT.svg": [
		69655,
		9655
	],
	"./Payment-Auth-HCSC.svg": [
		60206,
		206
	],
	"./Payment-Auth-Q5.svg": [
		91473,
		1473
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40408;
module.exports = webpackAsyncContext;